import type { BlokProps } from "@trydig/storyblok";
import { BlokWrap } from "@/components/bloks/BlokWrap";
import { CategoryCard } from "@/components/ui/CategoryCard";
import type { CategoryCardStoryblok } from "@/generated/sb/sb-types";
import { sbLink } from "@/lib/storyblok/link";

export const CategoryCardBlok = ({ blok }: BlokProps<CategoryCardStoryblok>) => {
	const href = sbLink(blok.link)?.href;
	return (
		<BlokWrap editable={blok} asChild>
			<CategoryCard
				asset={blok.asset}
				title={blok.title}
				caption={blok.caption}
				linkLabel={blok.linkLabel}
				href={href || "#"}
			/>
		</BlokWrap>
	);
};
